import React from 'react';
import ServiceAreaDetail from '../ServiceAreaDetail';

// Dedicated page component for /service-areas/bronx-ny
const BronxPage = () => <ServiceAreaDetail slug="bronx-ny" />;

export default BronxPage;
